module.exports = __webpack_public_path__ + "img/lg_ring_y_e_1_1@3x.45049238.png";